module.exports = __webpack_public_path__ + "static/img/recording.86085f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recording.png
// module id = ig+R
// module chunks = 1